import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

type ResignedMemberNoticeProps = {
  // 'extraMember' visas för en vänmedlemspost, som ska använda sitt ordinarie medlemskap i stället.
  variant?: 'resigned' | 'extraMember';
};

// Helskärms-skylt som visas för utträdda medlemmar på Min sida – hela portalen är låst.
export const ResignedMemberNotice = (props: ResignedMemberNoticeProps) => {
  const { variant = 'resigned' } = props;
  const { t } = useTranslation(['member', 'common']);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 3,
        p: 3,
      }}
    >
      <Typography variant='h5' sx={{ maxWidth: 520 }}>
        {variant === 'extraMember' ? t('member:extraMembership.noticeText') : t('member:resignedNotice.message')}
      </Typography>
      <Button variant='contained' onClick={() => navigate(RoutesEnum.Logout)}>
        {t('common:headerToolbar.logout')}
      </Button>
    </Box>
  );
};
